var generateStyle = function generateStyle(componentTheme) {
  return {
    footerSection: {
      display: 'flex',
      flex: '1 1 auto'
    },
    answerButtonWrapper: {
      flex: '1 1 auto',
      color: componentTheme.answerButtonWrapperColor,
      paddingLeft: componentTheme.answerButtonWrapperPadding
    },
    addAnswerButtonText: {
      paddingLeft: componentTheme.addAnswerButtonText
    }
  };
};
export default generateStyle;